import React from "react";
import styled from "styled-components";
import { BlueLED } from "../../elements/led/LEDelement";

const Chip = styled.div.attrs({
  className: "ml-2 d-flex align-items-center"
})`
  float: left;
  padding: 2px 10px;
  border-radius: 12px;
  background-color: #f0f4ff;
  border: 1px solid #d0dbff;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
`;

const SmallBlueLED = styled(BlueLED)`
  width: 12px;
  height: 12px;
`;

const Label = styled.span`
  margin-left: 6px;
`;

const formatPercent = progress => {
  if (!progress || !progress.totalPitches) {
    return "0%";
  }
  const pct = Math.round((progress.completedPitches / progress.totalPitches) * 100);
  return `${Math.min(pct, 100)}%`;
};

const KeyframeCutProgressIndicator = ({ progress }) => {
  if (!progress || !progress.totalPitches) {
    return null;
  }
  return (
    <Chip>
      <SmallBlueLED />
      <Label>Cutting Keyframes {formatPercent(progress)}</Label>
    </Chip>
  );
};

export default KeyframeCutProgressIndicator;
